import styled, { css } from 'styled-components';
import { Box, theme } from '@agilize/components-core';
import { darken } from 'polished';
import { device } from '../tools/breakpoints.styles';

export const genericShared = () => css`
  address,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote,
  p,
  pre,
  dl,
  ol,
  ul,
  figure,
  hr,
  table,
  fieldset {
    margin-bottom: 1.3rem;
  }

  dd,
  ol,
  ul {
    margin-left: 1rem;
  }

  :root {
    font-family: ${theme.global.defaultFont};
  }
  @supports (font-variation-settings: normal) {
    :root {
      font-family: 'Inter var', sans-serif;
    }
  }

  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }

  @media screen and (max-width: 767px) {
    html {
      font-size: 9px;
    }
  }

  body {
    overflow-y: overlay;
    font-family: ${theme.global.defaultFont};
    font-size: 1.6rem;
    font-weight: normal;
    background-color: ${theme.colors.grey100};
    text-rendering: optimizeLegibility;
    padding-right: 0 !important;
  }

  .container {
    margin: 0 auto;
    width: 100%;
    max-width: ${theme.breakpoints[2]};

    ${device.mobile} {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  a {
    color: ${theme.colors.blue700};
    text-decoration: none;
    font-size: 1.2rem;
  }

  .agilize-table {
    width: 100%;

    &__thead th {
      border: none;
      padding: 0 20px ${theme.global.gutterSpace}px 20px;
      color: ${theme.colors.grey700};
    }

    &__tbody {
      box-shadow: 0 0 0 1px ${theme.colors.grey700};
      border-radius: 8px;

      tr:first-child td {
        border-top: none;
      }

      tr:not(first-child) td {
        border-top: 1px solid ${theme.colors.grey700};
        padding: ${theme.global.gutterSpace * 0.5}px ${theme.global.gutterSpace * 1.5}px;
        font-weight: 600;
        font-size: 1.4rem;
        line-height: 17px;
        color: ${theme.colors.grey900};
      }

      td:not(.table-col-align--left) {
        text-align: center;
      }
    }
  }
`;

export const GradientOverlay = styled.div`
  background-color: ${props => props.theme.colors.purple100};
  background-image: radial-gradient(circle at 50%, ${props => props.theme.colors.white} 0%, ${props => props.theme.colors.purple100} 90%);
  background-repeat: no-repeat;
  background-size: cover;
`;
